const newMapPresenter = require('./eventPresenter/mapPresenter');
const newSignaturePresenter = require('./eventPresenter/signaturePresenter');
const negotiateLink = require('./eventPresenter/negotiateLink');
const {
    clickEventListener,
    negotiateCssClass,
    setViewData,
    queryParser
} = require('gui');
const customerCode = queryParser.get('id') || 'tim';

module.exports = function eventPresenter(event) {
    const view = require('./eventPresenter.tpl.html');
    const c = {};
    const onClickListener = clickEventListener();
    const mapPresenter = newMapPresenter(event.location);
    const signaturePresenter = newSignaturePresenter(event.signature);

    c.activate = function(region) {
        view.activate(region);
        var code = event.eventCode;
        if(code && customerCode.slice(0,4).toLowerCase() === 'tine') {
            negotiateCssClass(view.eventWrapper, 'tine', true);
            negotiateCssClass(view.eventWrapper, code.toLowerCase(), true);
        }
        negotiateCssClass(view.eventWrapper, 'confirmed', event.isActual);
        negotiateCssClass(view.eventWrapper, 'lastConfirmed', event.lastConfirmed);
        negotiateCssClass(view.showInMap, 'has-location', hasLocation(event.location));
        negotiateCssClass(view.signature, 'has-signature', event.signature);
        negotiateCssClass(view.showInMapButton, 'has-location', hasLocation(event.location));
        negotiateCssClass(view.signatureButton, 'has-signature', event.signature);
        negotiateCssClass(view.signatureNameExclusive, 'has-signatureNameExclusive', event.signatureNameExclusive);
        negotiateCssClass(view.signatureNameExclusiveSmall, 'has-signatureNameExclusive', event.signatureNameExclusive);

        negotiateLink(view.eventLink, event.url);
        negotiateLink(view.eventLinkButton, event.url);

        onClickListener.add(view.showInMap, onShowInMap);
        onClickListener.add(view.signature, onShowSignature);
        onClickListener.add(view.showInMapButton, onShowInMap);
        onClickListener.add(view.signatureButton, onShowSignature);
        let viewData = {...event, signatureNameExclusiveSmall: event.signatureNameExclusive};
        setViewData(view, viewData);
    };

    function hasLocation(location) {
        return location
            && location.latitude
            && location.longitude;
    }

    c.deactivate = function() {
        onClickListener.remove(view.showInMap, onShowInMap);
        onClickListener.remove(view.signature, onShowSignature);
        onClickListener.remove(view.showInMapButton, onShowInMap);
        onClickListener.remove(view.signatureButton, onShowSignature);
        view.deactivate();
    };

    function onShowInMap() {
        mapPresenter.show(view.showInMap);
    }

    function onShowSignature() {
        signaturePresenter.show(view.signature);
    }

    return c;
};
